
import AirRoadHeader from './components/Header.vue';
import AirRoadFilters from './components/Filters.vue';
import JobsTable from './components/JobsTable.vue';
import LegChoose from './components/LegChoose.vue';
import PackageStep from './components/PackageStep.vue';
import Services from './components/Services.vue';
import ConfirmStep from './components/ConfirmStep.vue';
import PendingStep from './components/PendingStep.vue';

import { bookAirRoadJob, getAirRoadJobsToBook, lookupCustomer } from '@/api';
import LookupCustomerCode from '@/components/jobBooking/AdvancedJobBooking/LookupCustomerCode.vue';
import DatePicker from '@/components/searchPage/DatePicker.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Button from '@/components/UI/button/Button.vue';
import StopDrawing from '@/components/jobDetailed/StopDrawing/StopDrawing.vue';
import StateSelect from '@/components/searchPage/components/StateSelect/StateSelect.vue';

import ToggleButton from '@/components/UI/ToggleButton.vue';
import TableList from '@/components/UI/TableList.vue';
import DateTimezoneToggle from '@/components/UI/dateTimezoneToggle/DateTimezoneToggle.vue';
import LookupSuburb from '@/components/UI/lookups/LookupSuburb.vue';
import { addDays } from 'date-fns';

import { User } from '@/models/main';
import {
  AirRoadBookingProductChoosenData,
  AirRoadBookingProductsToBook,
  AirRoadBookingRequest,
  AirRoadBookingStateData,
  AirRoadBookingStopToBook,
  AirRoadJobData,
  AirRoadJobPackageData,
  AirRoadJobProductData,
  AirRoadJobsRequestData,
  AirRoadJobsResponseData,
  AirRoadBookingSpecialOptions,
  ARServiceItem,
  ARServiceItemList,
  AirRoadFiltersPayload,
  AirRoadFiltersCheckboxes,
} from '@/models/airRoad';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { notificationErrorText, timeZoneDefault } from '@/utils/PortalConstants';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { buildPackedProducts } from '@/utils/Common';
import { ARServicesDeliveryList, ARServicesPickupList } from '@/utils/PortalConstants';

@Component({
  components: {
    AirRoadHeader,
    AirRoadFilters,
    JobsTable,
    LegChoose,
    PackageStep,
    Services,
    ConfirmStep,
    PendingStep,
    BackButton,
    Button,
    DatePicker,
    DateTimezoneToggle,
    LookupCustomerCode,
    LookupSuburb,
    StateSelect,
    StopDrawing,
    ToggleButton,
    TableList,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class AirRoadJobs extends Vue {
  public user!: User;
  public loading = false;

  public autocompleteCustomer = lookupCustomer;

  public ARServicesDeliveryList: ARServiceItemList = { ...ARServicesDeliveryList };
  public ARServicesPickupList: ARServiceItemList = { ...ARServicesPickupList };
  public ARServicesDeliveryListDefault: ARServiceItemList = JSON.parse(JSON.stringify(ARServicesDeliveryList));
  public ARServicesPickupListDefault: ARServiceItemList = JSON.parse(JSON.stringify(ARServicesDeliveryList));

  public dates: string[] = [];
  public datesDefault: string[] = [];
  public selectedProduct = null;

  // CUSTOMER CODE
  public customerCode = '';
  // WAREHOUSE
  public selectedStates: string[] = [];
  // SEARCH
  public searchValue = '';
  public timeout: ReturnType<typeof setTimeout>;
  // CHECKBOXES
  public checkboxes: AirRoadFiltersCheckboxes = {
    only920Driver: true,
    exclude920Driver: false,
    fromWarehouse: false,
    toWarehouse: false,
  };

  // PAGE DATA
  public pageData: AirRoadJobsResponseData = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };
  public tableData: AirRoadJobData[] = [];
  public tableOpenedJobIdx = -1;

  public jobDefaultData: AirRoadJobData = {
    id: 0,
    rockhopper_id: 0,
    rockhopper_date: '',
    booked_at: '',
    reference_1: '',
    reference_2: '',
    reference_3: '',
    customer: '',
    status: 0,
    stops: [],
    products: [],
    error_message: '',
    booked_by: '',
    split_base: 0,
    priority: false,
    connote: '',
    labels: false,
    json_used_for_booking: null,
    exclude_leg: null,
    customer_code: '',
    error_text: '',
    special_options: [],
  };

  // Steps:
  // 1. start_quick
  // 1. start_single
  // 2. leg_choose
  // 3. package
  // 4. confirm
  // 5. pending
  public bookingState: AirRoadBookingStateData = {
    quickJobs: false,
    step: 'start',
    allChosen: false,
    chosenJobs: [],
    singleJobChosen: { ...this.jobDefaultData },
  };

  public jobsToBook: AirRoadJobData[] = [];
  public jobsToBookOriginal: AirRoadJobData = { ...this.jobDefaultData };

  public specialOptions: AirRoadBookingSpecialOptions[] = [];
  public withAllocation = false;

  // PAGINATION
  public pagination = {
    page: 1,
    current: 1,
    total: 0,
    perPage: 10,
    visible: 7,
    perPageOptions: [1, 5, 10, 50, 100],
  };

  // PACKAGE STEP
  //
  public productsToDrop: AirRoadJobProductData[] = [];
  public productsPacked: AirRoadJobPackageData[] = [];
  public productDefaultData = {
    _id: 0,
    serial: '',
    model: '',
    description: '',
    quantity: 0,
    goods_code: '',
    weight: 0,
    volume: '',
    length: 0,
    width: 0,
    height: 0,
    quant_id: 0,
    from_stop: 0,
    to_stop: 0,
  };
  public productChosen: AirRoadBookingProductChoosenData = {
    cartonEditing: false,
    palletEditing: false,
    split: false,
    splitCounter: 1,
    data: {
      event: {
        product: { ...this.productDefaultData },
      },
      type: 'none',
    },
  };

  // Adding new address dialog
  public dialog = false;

  public get currentLegNumber(): number {
    return this.jobsToBook[0].leg_2_chosen ? 2 : 1;
  }

  // // // // // //
  // ACTIONS:
  // // // // // //

  public handleFiltersSubmit(filters: AirRoadFiltersPayload) {
    this.dates = filters.dates;
    this.customerCode = filters.customerCode;
    this.selectedStates = filters.selectedStates;
    this.searchValue = filters.searchValue;
    this.checkboxes = filters.checkboxes;
    this.pagination.current = 1;
    this.getAirRoadWrapper();
  }

  public setSpecialOptions(specialOptions: AirRoadBookingSpecialOptions[]) {
    this.specialOptions = specialOptions;
  }

  public withAllocationChanged(value: boolean): void {
    this.withAllocation = value;
  }

  public tableJobRowClick(idx) {
    if (this.tableOpenedJobIdx === idx) {
      this.tableOpenedJobIdx = -1;
    } else {
      this.tableOpenedJobIdx = idx;
    }
  }

  // API:

  // Single job
  // Build
  public buildJsonToBook(productsPacked, job, jobOriginal) {
    // Collect products:
    const productsToBook: AirRoadBookingProductsToBook[] = buildPackedProducts(productsPacked);
    // Collect stops
    const stopsToBook: AirRoadBookingStopToBook[] = [];
    job.stops.map((stop, idx) => {
      const stopNumberToRemove = job.leg_2_chosen ? 0 : 2;
      if (stopNumberToRemove !== idx) {
        stopsToBook.push({
          name: stop.name,
          stop_number: stop.stop_number,
          address_line_1: stop.address_line_1 ? stop.address_line_1 : '',
          address_line_2: stop.address_line_2,
          suburb: stop.suburb,
          postcode: stop.post_code,
          state: stop.state,
          original_stop: jobOriginal.stops[idx].id,
        });
      }
    });
    // Final JSON
    const params: AirRoadBookingRequest = {
      job_id: job.rockhopper_id,
      job_date: job.rockhopper_date,
      ar_booked_leg: job.leg_2_chosen ? 2 : 1,
      items: productsToBook,
      ar_stops: stopsToBook,
      special_options: this.specialOptions,
    };
    return params;
  }
  // Book
  public async bookJob() {
    const params = this.buildJsonToBook(this.productsPacked, this.jobsToBook[0], this.jobsToBookOriginal);
    let result = false;
    await bookAirRoadJob(params, this.withAllocation)
      .then(() => {
        this.productsPacked = [];
        this.productChosen = {
          cartonEditing: false,
          palletEditing: false,
          split: false,
          splitCounter: 1,
          data: {
            event: {
              product: { ...this.productDefaultData },
            },
            type: 'none',
          },
        };
        this.$notify({
          group: 'network',
          text: 'Job has been queued to book to Airroad',
          type: 'success',
          duration: 3000,
        });
        this.clearARServicesList();
        result = true;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error when booking a job',
          text: notificationErrorText,
          type: 'warn',
        });
      });
    return result;
  }

  private clearARServicesItem(service: ARServiceItem, serviceDefaultData: ARServiceItem): void {
    service.chosen = false;
    service?.contact_name ? (service.contact_name = '') : null;
    service?.contact_phone ? (service.contact_phone = '') : null;
    service?.description ? (service.description = '') : null;
    service?.date ? (service.date = serviceDefaultData.date) : null;
    service?.dateTo ? (service.dateTo = serviceDefaultData.dateTo) : null;
    service?.dateFrom ? (service.dateFrom = serviceDefaultData.dateFrom) : null;
    service?.time ? (service.time = serviceDefaultData.time) : null;
  }

  private clearARServicesList(): void {
    Object.values({ ...this.ARServicesDeliveryList }).map((service, idx) => {
      this.clearARServicesItem(service, Object.values(this.ARServicesDeliveryListDefault)[idx]);
    });
    Object.values({ ...this.ARServicesPickupList }).map((service, idx) => {
      this.clearARServicesItem(service, Object.values(this.ARServicesPickupListDefault)[idx]);
    });
  }

  // Pagination
  public async updatePagination() {
    await this.getAirRoadWrapper();
    // Pagination corrections:
    this.pagination.total = Math.ceil(this.pageData.count / Number(this.pagination.perPage));
    if (this.pagination.current === 0 && this.pagination.total >= 1) {
      this.pagination.current = 1;
    }
    if (this.pagination.current > this.pagination.total) {
      this.pagination.current = this.pagination.total;
    }
  }

  // Next
  public async nextStepClick() {
    let newStep: string | null = '';
    this.loading = true;
    // chosenJobs not empty!
    // Start step
    if (this.bookingState.step === 'start') {
      // MOVI THIS
      const chosenJobs = this.tableData.filter(x => this.bookingState.chosenJobs.indexOf(x.rockhopper_id) !== -1);
      if (chosenJobs.length > 0) {
        this.jobsToBook = chosenJobs;
      }
      if (this.bookingState.quickJobs) {
        newStep = 'confirm';
      } else {
        this.jobsToBookOriginal = { ...JSON.parse(JSON.stringify(this.jobsToBook[0])) };
        newStep = 'leg_choose';

        if (this.jobsToBook[0].exclude_leg) {
          this.jobsToBook[0].leg_2_chosen = this.jobsToBook[0].exclude_leg === 1 ? true : false;
        }
      }
    }
    // Leg choose step
    if (this.bookingState.step === 'leg_choose') {
      // leg_2_chosen
      const curLeg = this.jobsToBook[0].leg_2_chosen ? 2 : 1;
      this.productsToDrop = [
        ...this.jobsToBook[0].products.filter(x => x.from_stop === curLeg && x.to_stop === curLeg + 1),
      ];
      newStep = 'package';
    }
    if (this.bookingState.step === 'package') {
      newStep = 'services';
    }
    if (this.bookingState.step === 'services') {
      newStep = 'confirm';
    }
    // Confirm step
    if (this.bookingState.step === 'confirm') {
      newStep = 'confirm';
      // Set the 'pending' step only if the job is booked
      await this.bookJob().then(res => {
        if (res) {
          newStep = 'pending';
        }
      });
    }
    // Apply
    this.bookingState.step = newStep;
    setTimeout(() => {
      this.loading = false;
    }, 400);
  }
  // Prev
  public backBtnClicked() {
    this.loading = true;
    let prevStep = '';
    // Start step
    if (this.bookingState.step === 'start') {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        window.close();
      }
    }
    // Confirm step
    if (this.bookingState.step === 'confirm') {
      if (this.bookingState.quickJobs) {
        prevStep = 'start';
        this.clearChosenData();
      } else {
        prevStep = 'services';
      }
    }
    // Leg choosing step
    if (this.bookingState.step === 'leg_choose') {
      prevStep = 'start';
      this.clearChosenData();
    }
    // Package step
    if (this.bookingState.step === 'package') {
      prevStep = 'leg_choose';
    }
    if (this.bookingState.step === 'services') {
      prevStep = 'package';
    }
    // Pending step
    if (this.bookingState.step === 'pending') {
      prevStep = 'start';
      this.clearChosenData();
    }
    // Apply
    this.bookingState.step = prevStep;
    setTimeout(() => {
      this.loading = false;
    }, 400);
  }

  // Clear all
  public clearChosenData() {
    this.bookingState = {
      ...this.bookingState,
      step: 'start',
      allChosen: false,
      chosenJobs: [],
      singleJobChosen: { ...this.jobDefaultData },
    };
  }

  // Watchers:
  //
  // Pagination
  @Watch('pagination.perPage')
  private perPageSelectChanged() {
    this.pagination.current = 1;
    this.bookingState.chosenJobs = [];
    this.updatePagination();
  }

  // WRAPPERS
  public async getAirRoadWrapper(): Promise<void> {
    this.loading = true;
    this.tableOpenedJobIdx = -1;
    this.pageData = { count: 0, next: '', previous: '', results: [] };
    this.tableData = [];
    const endpointParams: AirRoadJobsRequestData = {
      ordering: '',
      search: this.searchValue,
      rockhopper_date_gte: this.dates[0],
      rockhopper_date_lte: this.dates[1],
      customer_code: this.customerCode,
      quick_booking: this.bookingState.quickJobs,
      page: this.pagination.current,
      page_size: Number(this.pagination.perPage),
      wh_state: this.selectedStates,
      only_920_driver: this.checkboxes.only920Driver,
      exclude_920_driver: this.checkboxes.exclude920Driver,
      from_warehouse: this.checkboxes.fromWarehouse,
      to_warehouse: this.checkboxes.toWarehouse,
    };
    await getAirRoadJobsToBook(endpointParams)
      .then((res: AirRoadJobsResponseData) => {
        this.pageData = res;
        this.tableData = res.results;
        this.pagination.total = Math.ceil(res.count / Number(this.pagination.perPage));
        this.loading = false;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error loading AirRoad data',
          text: notificationErrorText,
          type: 'warn',
        });
        this.loading = false;
      });
  }

  private mounted() {
    const userTimeZone = this.user.timezone || timeZoneDefault;
    const fromDate = format(utcToZonedTime(addDays(new Date(), -7), userTimeZone), 'yyyy-MM-dd'); // today
    const toDate = format(utcToZonedTime(addDays(new Date(), 5), userTimeZone), 'yyyy-MM-dd'); // today
    this.datesDefault = [fromDate, toDate];
    this.dates = [...this.datesDefault];
    this.getAirRoadWrapper();
  }
}
